<template>
    <b-modal ref="profile_modal"
             size="lg"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">ID:{{this.item.id}}</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">

                <b-overlay :show="is_load" rounded="sm">

                    <div class="panel-content">
                        <div class="d-flex flex-column align-items-center justify-content-center p-4">
                            <h5 class="mb-0 fw-700 text-center mt-3">
                                {{this.item.title}}
                                <small class="text-muted mb-0">
                                    {{__t('ROLE_ACCESS_INFO')}}
                                </small>
                            </h5>
                        </div>

                        <div>
                            <b-tabs content-class="mt-3">
                                <b-tab v-for="(tab,index) in tabs" @click="set_active(index)" :title="get_tab_title(tab)" :key="index" :active="tab.is_active">
                                    <template slot="title">
                                        {{get_tab_title(tab)}}
                                        <b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
                                    </template>
                                    <component
                                        @on_change_attribute="on_change_attribute"
                                        v-bind:is="tab.index" :role_item="item">
                                    </component>
                                </b-tab>
                            </b-tabs>
                        </div>
                        <div>
                        </div>
                    </div>

                </b-overlay>
            </div>
            <!--FOOTER -->
        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <button type="button" @click="remove(false)" class="btn btn-outline-danger waves-effect waves-themed mr-5 pl-5 pr-5" v-if="item_id > 0">
                    {{ __t('REMOVE') }}
                </button>

                <button type="button" @click="close()" class="btn btn-secondary waves-effect waves-themed">
                    {{ __t('CLOSE') }}
                </button>

                <button type="button" v-on:click="save_item" class="btn btn-primary waves-effect waves-themed">
                    {{ __t('SAVE') }}
                </button>
            </div>
        </template>
    </b-modal>
</template>



<script>

import role_info from "./tabs/role_info.vue";
import role_market from "./tabs/role_market.vue";
import role_delivery from "./tabs/role_delivery.vue";
import role_notification from "./tabs/role_notification.vue";

import tg_info from "./tabs/tg/tg_info.vue";
import tg_restaurants from "./tabs/tg/tg_restaurants.vue";
export default {
    name: "role_modal",
    props : {
        modal_position : {
            type : String,
            default : "left"
        },
    },

    components : {
        role_info,
        role_market,
        role_delivery,
        role_notification,
        tg_info,
        tg_restaurants
    },

    data() {
        return {
            item_id : 0,
            provider_id : 0,
            item: {
                id : 0,
                provider_id : 0,
                location_ids : [],
                delivery_ids : [],
            },
            is_load: false,
            is_show_modal: false,
            tabs : []
        }
    },

    created () {
        EventBus.$on("role_edit", this.work_click);
        EventBus.$on("role_close",this.close);
    },

    methods : {

        work_click(_id,provider_id) {
            this.is_show_modal = true;
            this.item.provider_id = provider_id;

            this.item_id = _id;
            this.provider_id = provider_id;

            this.load_role();
        },

        on_change_attribute(atr_name,atr_val) {
            console.log('change_atr',atr_name,atr_val);
            if(this.item.hasOwnProperty(atr_name)) {
                this.item[atr_name] = atr_val;
                this.$set(this.item,atr_name,atr_val);
            }
        },

        get_tab_title (tab) {
            if(tab.count > 0) {
                return tab.title;
            }
            return tab.title;
        },

        set_active (obj) {
            for (let tab in this.tabs) {
                this.tabs[tab].is_active = false;
            }

            this.tabs[obj].is_active = true;
            EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
        },

        async load_role () {
            this.is_load = true;
            this.tabs = [];
            await api.get(this.role_url).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {

                    this.item = data.data;
                    this.push_tabs();
                }
            }).catch(({response}) => {
                console.log(response);
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,position : "b-toaster-top-left"})
            });
        },

        async remove(is_force) {
            this.$emit('remove',this.item)
            this.close();
        },

        async save_item() {
            this.is_load = true;
            await api.put(this.role_url,this.item)
                .then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        this.close();
                        EventBus.$emit("reload_roles");
                    }
                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status,
                        position : "b-toaster-top-right",
                    })
                });
        },

        close () {
            this.item = {
                id : 0,
                provider_id : 0,
                location_ids : [],
                delivery_ids : [],
            };

            this.tabs = [];
            this.is_show_modal = false;
        },


        push_tabs() {
            this.default_tabs.map(item => {
                this.tabs.push({
                    title: item.title,
                    is_active: false,
                    is_load: false,
                    index: item.index,
                });
            });
        },
    },

    computed : {

        default_tabs() {

            if(parseInt(this.provider_id) === 1) {
                return this.order_tabs;
            }

            if(this.is_tg) {
                return this.tg_tabs;
            }

            return  [];
        },

        is_tg() {
            return parseInt(this.provider_id) === 2;
        },

        is_tg_bot() {
            return String(this.item_id).startsWith('tg_');
        },

        real_item_id() {

            if (this.is_tg_bot) {
                return parseInt(String(this.item_id).replace('tg_', ''));
            }

            return parseInt(this.item_id);
        },

        role_url() {
            if (this.is_tg_bot) {
                return '/internal/v1/roles/' + parseInt(this.provider_id) + '/telegram/' + this.real_item_id;
            }

            return '/internal/v1/roles/' + parseInt(this.provider_id) + '/access/' + this.real_item_id;
        },


        is_catalog () {

        },

        tg_tabs() {

            if(this.is_tg_bot) {
                return this.tg_bot_tabs;
            }

            if(this.is_tg) {
                return  [
                    {
                        "title": this.__t('MAIN_SETTINGS'),
                        "index": "role_info",
                        is_active:true,
                    },
                    {
                        "title": this.__t('TG_SETTINGS'),
                        "index": "tg_info",
                        is_active:false,
                    },
                    {
                        "title": this.__t('REST_FILTER'),
                        "index": "tg_restaurants",
                        is_active:false,
                    }

                ]
            }



            return  [
                {
                    "title": this.__t('MAIN_SETTINGS'),
                    "index": "role_info",
                    is_active:true,
                },
                /*{
                    "title": this.__t('ORDER_NOTIFICATION'),
                    "index": "role_notification",
                    is_active:false,
                }*/
            ];
        },

        tg_bot_tabs() {
            return  [
                {
                    "title": this.__t('MAIN_SETTINGS'),
                    "index": "tg_info",
                    is_active:true,
                },
                {
                    "title": this.__t('REST_FILTER'),
                    "index": "tg_restaurants",
                    is_active:false,
                }
            ];
        },

        order_tabs() {

            return [
                {
                    "title": this.__t('MAIN_SETTINGS'),
                    "index": "role_info",
                    is_active:true,
                },
                {
                    "title": this.__t('MARKET_FILTER'),
                    "index": "role_market",
                    is_active:false,
                },
                {
                    "title": this.__t('DELIVERY_FILTER'),
                    "index": "role_delivery",
                    is_active:false,
                },
            ];
        },


        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }

            return "modal-dialog-right modal-lg";
        },
    }
}
</script>


<style scoped>

</style>
